<bz-return-btn-arrow class="btn-back">
  <p>{{'back' | transloco}}</p>
</bz-return-btn-arrow>

<div class="all-advice-wrapper">
  <p class="all-advice-title">
    Блог
    <span class="count">{{(adviceDayList | async)?.length}}</span>
  </p>

  <ng-container *screen="0">
    <div class="external-input-wrapper">
      <ng-container [ngTemplateOutlet]="inputWrapper"></ng-container>
    </div>
  </ng-container>

  <ng-container *screen="1" [ngTemplateOutlet]="inputWrapper"></ng-container>

  <ng-template #inputWrapper>
    <div class="input-wrapper">
      <img class="search-icon" src="../../../../assets/search.svg" alt="serach" [title]="'search' | transloco">
      <input class="search-input" [formControl]="inputSearch" (click)="search()" type="text"
        [placeholder]="'searchAdviceTip' | transloco">
    </div>
  </ng-template>

  <div class="tips-day">
    <div class="tips-card-wrapper" *ngIf="(adviceDayList | async)?.advices.length > 0">
      <div *ngFor="let tip of (adviceDayList | async)?.advices" (click)="toAdviceTip(tip?.nameEn)" class="tip-card">
        <picture class="tip-image">
          <source [srcset]="images + tip.photo + '.webp'" type="image/webp">
          <img bz-image [src]="images + 'png/' + tip.photo + '.png'" [title]="tip.title" [alt]="tip.title">
        </picture>
        <div class="description-wrapper">
          <p class="tip-description">{{tip.title}}</p>
        </div>
      </div>
    </div>

    <div class="no-search-tips" *ngIf="(adviceDayList | async)?.advices.length == 0">
      <p class="no-search-inner">{{'noCurrentAdviceTips' | transloco}}</p>
    </div>

  </div>

</div>
